import { useStaticQuery, graphql } from 'gatsby'

export const useCallout2Query = () => {
  const { wpPage, wp } = useStaticQuery(graphql`
    query Callout2Query {
      wpPage(title: { eq: "Home" }) {
        callout2 {
          callout2 {
            backgroundImageMobile {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, quality: 100, formats: [WEBP])
                }
              }
            }
            backgroundImageDesktop {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, quality: 100, formats: [WEBP])
                }
              }
            }

            vanImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP, sizes: "(min-width: 1024px) 29vw, 76vw")
                }
              }
            }
            vanImageAltText
            foregroundImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP, sizes: "100vw")
                }
              }
            }
            foregroundImageDesktop {
              localFile {
                childImageSharp {
                  gatsbyImageData(formats: WEBP, sizes: "34vw")
                }
              }
            }
            foregroundImageAltText
            title
            buttonText
          }
        }
      }
      wp {
        acfOptionsCommonItems {
          commonItems {
            phoneNumber
          }
        }
      }
    }
  `)
  return { wpPage, wp }
}
